import React from 'react';
import { Hourglass } from 'lucide-react';
import { Card } from '../../../components/ui/card';
import { fmtFecha } from './atencionUtils';
import { ColumnasSelector, useColumnas } from './ColumnasSelector';
import { TablaAtencion } from './TablaAtencion';

const COLUMNAS = [
  { key: 'ticket_id', label: 'Ticket', fija: true, className: 'tabular-nums text-slate-500', render: (t) => `#${t.ticket_id}` },
  { key: 'fecha', label: 'Creado', className: 'whitespace-nowrap', render: (t) => fmtFecha(t.fecha) },
  { key: 'estado', label: 'Estado', defecto: false },
  { key: 'grupo', label: 'Grupo' },
  { key: 'motivo', label: 'Motivo', className: 'text-slate-600' },
  { key: 'asunto', label: 'Asunto', className: 'max-w-[340px] truncate text-slate-700', render: (t) => <span title={t.asunto}>{t.asunto || '—'}</span> },
  { key: 'dias', label: 'Días abierto', right: true, className: 'font-semibold text-amber-700' },
];

// B8: los 10 tickets abiertos con más días (dentro del período filtrado).
export const AtencionAbiertosViejos = ({ lista = [] }) => {
  const cols = useColumnas('abiertos', COLUMNAS);
  return (
    <Card className="mb-6 p-5 lg:p-6" data-testid="atencion-abiertos-viejos">
      <div className="mb-4 flex items-center gap-2">
        <h2 className="flex items-center gap-2 text-base font-semibold text-slate-800"><Hourglass className="h-4 w-4 text-amber-500" /> Abiertos más viejos</h2>
        <div className="ml-auto"><ColumnasSelector columnas={COLUMNAS} estado={cols} testId="atencion-abiertos-cols" /></div>
      </div>
      <TablaAtencion columnas={COLUMNAS} ver={cols.ver} filas={lista} rowKey={(t) => t.ticket_id}
        rowTestId={(t) => `atencion-abierto-${t.ticket_id}`} vacio="No hay tickets abiertos en el período." />
    </Card>
  );
};
